module.exports = [
  /* ce cas inclus une commande annulee */
  {
    code: 0,
    name: 'missing-products',
    title: 'Paiement non-ajusté pour produits manquants',
    description: 'Le débit banquaire n\'a pas été ajusté pour produits manquants lors de la distribution'
  }
];